<template>
  <div class="bulletin-vitrine">

    <!-- FLOATING CONTROLS -->
    <div class="bulletin-vitrine__controls bulletin-vitrine__controls--left">
      <b-button
        variant="light"
        size="sm"
        @click="goBack"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="14"
          class="mr-50"
        />
        Retour
      </b-button>
    </div>

    <div class="bulletin-vitrine__controls bulletin-vitrine__controls--right">
      <b-button
        v-if="$can('CHANTIER:create')"
        variant="light"
        size="sm"
        :disabled="regenerating"
        @click="regenerate"
      >
        <b-spinner
          v-if="regenerating"
          small
          class="mr-50"
        />
        <feather-icon
          v-else
          icon="RefreshCwIcon"
          size="14"
          class="mr-50"
        />
        Régénérer
      </b-button>
    </div>

    <p
      v-if="regenerateError"
      class="bulletin-vitrine__toast"
    >
      {{ regenerateError }}
    </p>

    <!-- LOADING -->
    <div
      v-if="loading"
      class="bulletin-vitrine__state"
    >
      <b-spinner class="mb-1" />
      <p class="mt-1 mb-0">
        Chargement du bulletin…
      </p>
    </div>

    <!-- ERROR -->
    <div
      v-else-if="error"
      class="bulletin-vitrine__state bulletin-vitrine__state--error"
    >
      <feather-icon
        icon="AlertTriangleIcon"
        size="32"
      />
      <p class="mt-1 mb-0">
        Impossible de charger le bulletin.
      </p>
    </div>

    <!-- EMPTY -->
    <div
      v-else-if="!bulletin || !bulletin.html"
      class="bulletin-vitrine__state"
    >
      <feather-icon
        icon="FileTextIcon"
        size="32"
      />
      <p class="mt-1 mb-0">
        Aucun bulletin de synthèse n'a encore été généré.
      </p>
    </div>

    <!-- BULLETIN (sandboxed iframe) -->
    <iframe
      v-else
      :srcdoc="bulletin.html"
      sandbox="allow-scripts allow-popups"
      title="Bulletin de synthèse"
      class="bulletin-frame"
    />

  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'

export default {
  name: 'ChantiersBulletinView',
  components: {
    BButton,
    BSpinner,
  },
  data() {
    return {
      bulletin: null,
      loading: true,
      error: false,
      regenerating: false,
      regenerateError: null,
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      this.error = false
      try {
        this.bulletin = await this.$http.myressif.chantiers.bulletin()
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
    async regenerate() {
      this.regenerating = true
      this.regenerateError = null
      try {
        await this.$http.myressif.chantiers.regenerateBulletin()
        await this.load()
      } catch (e) {
        this.regenerateError = 'La régénération du bulletin a échoué.'
      } finally {
        this.regenerating = false
      }
    },
    goBack() {
      this.$router.push({ name: 'chantiers-list' })
    },
  },
}
</script>

<style scoped lang="scss">
$at-green:   #1c4d4d;
$at-orange:  #ff6131;
$at-ink-500: #5A7373;

.bulletin-vitrine {
  position: fixed;
  inset: 0;
  background: #fff;

  &__controls {
    position: fixed;
    top: 16px;
    z-index: 20;

    &--left { left: 16px; }
    &--right { right: 16px; }

    .btn {
      box-shadow: 0 2px 10px rgba(15, 31, 31, .18);
    }
  }

  &__toast {
    position: fixed;
    top: 60px;
    right: 16px;
    z-index: 20;
    margin: 0;
    padding: 8px 14px;
    background: rgba(255, 97, 49, .12);
    color: $at-orange;
    border: 1px solid rgba(255, 97, 49, .3);
    border-radius: 8px;
    font-size: 13px;
    box-shadow: 0 2px 10px rgba(15, 31, 31, .12);
  }

  &__state {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: $at-ink-500;
    z-index: 10;

    &--error { color: $at-orange; }
  }
}

.bulletin-frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
